// @flow
import React from 'react';

import { TAB } from 'Client/cms/toolkit/constants';
import { Line } from 'Components/frameworks/line/Line.jsx';
import { tabResolver } from './tab.resolver';

export const tabDescriptor = {
  name: TAB,
  component: (props: *) => <Line props={props} />,
  props: tabResolver.props,
};
